var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-textarea',{attrs:{"clearable":"","clear-icon":"cancel","label":"Text","value":"This is clearable text."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }